import {AfterViewInit, Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {UserService} from '../../shared/services/user_service';

@Component({
  selector: 'notd-legal-info',
  templateUrl: './legal-info.component.html',
  styleUrls: ['./legal-info.component.scss']
})
export class LegalInfoComponent implements OnInit, AfterViewInit {
  @ViewChild('legalInfoForm', {static: false}) public myLegalInfoForm: NgForm;
  @Output() legalInfoEmitter: EventEmitter<any> = new EventEmitter(true);

  legalInfo: any;

  componentMessage = {value: undefined, css: ''};
  refreshing = false;
  address;
  user;

  constructor(private userService: UserService) { }

  ngOnInit() {
    this.legalInfo = {};
    this.address = {};
    this.refreshLegalInfo();
  }

  ngAfterViewInit() {
    this.legalInfoEmitter.emit(
      {
        form: this.myLegalInfoForm
      }
    );
  }

  refreshLegalInfo() {
    this.refreshing = true;
    this.userService.getProfile(true).then(
      (user: any) => {
        this.formatResponse(user);
        this.refreshing = false;
      },
      err => {
        this.legalInfo.legalAddress = {};
        this.address = {};
        this.legalInfo.fullLegalName = undefined;
        this.refreshing = false;
        console.log('Error', err);
      }
    );
  }

  saveLegalInfo(form: NgForm = null): Promise<any> {
    this.refreshing = true;
    const params: any = {};
    params.entity = 'company';
    params.full_legal_name = this.legalInfo.fullLegalName;
    params.address_line1 = this.legalInfo.legalAddress.line1;
    params.address_line2 = this.legalInfo.legalAddress.line2;
    params.address_region = this.legalInfo.legalAddress.region;
    params.postalCode = this.legalInfo.legalAddress.postalCode;
    params.countryCode = this.address.countryCode;
    params.address_city = this.address.city;

    return this.userService.updateLegalInfo(params).then(
      (user: any) => {
        this.refreshing = false;
        this.componentMessage.value = 'Legal information saved';
        this.componentMessage.css = '';
        this.formatResponse(user);

        return user;
      },
      err => {
        this.componentMessage.css = 'error';
        this.componentMessage.value = 'Error';
        if (err.statusText) {
          this.componentMessage.value += ' ' + err.statusText;
        }
        this.refreshing = false;
        console.error('Error', err);
        return err;
      }
    );
  }

  public stateEvent(state: any): void {
    if (state) {
      this.legalInfo.legalAddress.region = state.stateName;
    } else {
      this.legalInfo.legalAddress.region = '';
    }
  }

  public countryEvent(country: any): void {
    if (country) {
      this.address.countryCode = country.countryCode;
    } else {
      this.address.countryCode = undefined;
    }
  }

  private formatResponse(user: any) {
    this.legalInfo.fullLegalName = user.fullLegalName;
    this.legalInfo.legalAddress = user.legalAddress;

    if (user.legalAddress) {
      this.address = {
        city: user.legalAddress.city,
        countryCode: user.legalAddress.countryCode,
        region: user.legalAddress.region
      };
    } else {
      this.legalInfo.legalAddress = {};
      this.address = {
        countryCode: 'US'
      };
    }

    this.legalInfoEmitter.emit(
      {
        form: this.myLegalInfoForm,
        legalInfo: this.legalInfo,
        address: this.address
      }
    );
  }
}

